// Validation constants — single source of truth for field length limits.
// These values are used by UI maxLength attributes, JS validation, and DB CHECK constraints.
// Do not change a value here without also updating the corresponding database migration.

// Article / Event fields (stored in articles table)
export const ARTICLE_TITLE_MAX = 150;
export const ARTICLE_SUMMARY_MAX = 500;
export const ARTICLE_CONTENT_MAX = 10000;
export const ARTICLE_CONTENT_VIDEO_MAX = 500;
export const ARTICLE_IMAGE_CAPTION_MAX = 100;
export const ARTICLE_IMAGE_CREDIT_MAX = 100;
export const TAGS_MAX = 5;

// Group / Community fields (stored in communities table)
export const GROUP_NAME_MAX = 80;
export const GROUP_DESCRIPTION_MAX = 500;

// User profile fields (stored in users table)
export const USER_DISPLAY_NAME_MAX = 100;

// Password minimum — one rule for registration, password reset and the profile's change-password,
// checked as the person types (docs/briefs/2026-10-03-registration-confirm-first-addendum-2.md
// item 1). App-layer only: no DB CHECK and no migration; Supabase Auth keeps its own minimum.
export const PASSWORD_MIN_LENGTH = 8;

// Community interaction
export const JOIN_REQUEST_MESSAGE_MAX = 500;
export const INVITATION_MESSAGE_MAX = 1000;

// Federation application answers (request_data JSONB — no DB CHECK, app-layer only per the
// ratified federation schema: "field validation lives in app code, not the DB")
export const FEDERATION_APPLICATION_TEXT_MAX = 200;
export const FEDERATION_APPLICATION_LONGTEXT_MAX = 2000;

// Reports
export const REPORT_TEXT_MAX = 500;

// Share
export const SHARE_LINK_TEXT_MAX = 100;
